import { toast } from 'react-toastify';

class ErrorTrackingService {
  // Log error with comprehensive details
  log(error, context = {}) {
    const errorLog = {
      message: error.message,
      name: error.name,
      stack: error.stack,
      timestamp: new Date().toISOString(),
      context: {
        ...context,
        url: window.location.href,
        userAgent: navigator.userAgent
      }
    };

    // Console logging
    console.error('Error Log:', JSON.stringify(errorLog, null, 2));

    // Toast notification for user-friendly error display
    this.showErrorToast(errorLog.message);

    // Optional: Send to external error tracking service
    this.reportToExternalService(errorLog);
  }

  // Show user-friendly error toast
  showErrorToast(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  // Optional method to report to external service
  reportToExternalService(errorLog) {
    // Implement integration with services like Sentry, LogRocket, etc.
    // Example placeholder:
    // if (window.Sentry) {
    //   Sentry.captureException(new Error(errorLog.message), {
    //     extra: errorLog.context
    //   });
    // }
  }

  // Create a wrapper for async operations to handle errors consistently
  async wrapAsyncOperation(operation, context = {}) {
    try {
      return await operation();
    } catch (error) {
      this.log(error, context);
      throw error; // Re-throw to allow caller to handle if needed
    }
  }
}

const errorTrackingService = new ErrorTrackingService();
export default errorTrackingService;